import { useContext, useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import Header from "../components/Header";
import { RESULT_ROUTE_8 } from "../utils/consts";

function Table8() {
  const { col8 } = useContext(Context);

  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);
  const [check5, setCheck5] = useState(false);
  const [check6, setCheck6] = useState(false);
  const [check7, setCheck7] = useState(false);

  const navigate = useNavigate();

  const [wordd, setWordd] = useState(col8.word);
  const [res, setRes] = useState(0);

  const [c1, setC1] = useState(0);
  const [c2, setC2] = useState(0);
  const [c3, setC3] = useState(0);
  const [c4, setC4] = useState(0);
  const [c5, setC5] = useState(0);
  const [c6, setC6] = useState(0);
  const [c7, setC7] = useState(0);


  useEffect(() => {
    check1 ? setC1(1) : setC1(0);
    check2 ? setC2(1) : setC2(0);
    check3 ? setC3(1) : setC3(0);
    check4 ? setC4(1) : setC4(0);
    check5 ? setC5(1) : setC5(0);
    check6 ? setC6(1) : setC6(0);
    check7 ? setC7(1) : setC7(0);
  }, [check1, check2, check3, check4, check5, check6, check7]);

  useEffect(() => {
    const z =
      -5.60 +
      3.45 * c1 +
      3.64 * c2 +
      1.23 * c3 +
      1.63 * c4 +
      1.59 * c5 +
      1.19 * c6 +
      1.63 * c7;
    const p = Math.exp(z) / (1 + Math.exp(z));
    const num = p.toFixed(3);
    setRes(num);
  }, [c1, c2, c3, c4, c5, c6, c7]);

  useEffect(() => {
    res < 0.325 ? setWordd("низкая") : setWordd("высокая");
  }, [res]);

  function result() {
    const data = { c1, c2, c3, c4, c5, c6, c7, res, word: wordd };

    col8.setResult8(res);
    col8.setWord8(wordd);
    col8.setCols8({ c1, c2, c3, c4, c5, c6, c7});

    localStorage.setItem("data8", JSON.stringify(data));

    navigate(RESULT_ROUTE_8);
  }


  return (
    <div>
      <Header />
      <Container>
        <div style={{ padding: "1.25rem" }} className="tableCard">
          <h4>
            Определение вероятности развития метаболических нарушений у новорожденных от матерей с сахарным диабетом 1 типа
          </h4>
          <h6 className="fullname">Горячко А.Н., Рубникович С.П., Солнцева А.В., Пивченко Т.П., Уварова Е.В.</h6>
          <div className="descript">
            Математическая модель с компьютерной программой сопровождения, основанная на логистическом регрессионном анализе, позволяет с высокой вероятностью прогнозировать развитие метаболических нарушений у новорожденных от матерей с сахарным диабетом 1 типа.
          </div>
          <div style={{ marginTop: "1rem" }}>
            По результатам анализа 153 данных акушерско-гинекологического и соматического анамнеза, отягощенного течения беременности и особенностей послеродового периода у матерей, клинических проявлений, данных лабораторных и инструментальных исследований у доношенных младенцев в раннем неонатальном периоде установлены наиболее значимые факторы, ассоциированные с развитием метаболических нарушений у новорожденных детей от матерей с сахарным диабетом 1 типа. К фактором высокой статистической значимости отнесены: гипергликемия у матери во время беременности ({">"}5,6 ммоль/л), масса тела новорожденного более 90-го процентиля, энцефалопатия  новорожденного или другие нарушения церебрального статуса, синдромом дыхательных расстройств, врожденный порок сердца и/или врожденные аномалии системы кровообращения, нарушение гомеостаза глюкозы (неонатальная гипогликемия) ({"<"}2,6 ммоль/л) в течение раннего неонатального периода, гиперплазия поджелудочной железы у новорожденного (увеличение размеров тела ({">"}5,9 мм), и/или хвоста ({">"}9,3 мм), и/или выше референсных значений).
          </div>
          <div style={{ marginTop: "1rem" }} className="checkboxes">
            <Form>
              <Form.Group controlId="check1">
                <Form.Check
                  onChange={() => setCheck1(!check1)}
                  checked={check1}
                  type="checkbox"
                  label="Гипергликемия у матери во время беременности (>5,6 ммоль/л)"
                />
              </Form.Group>
              <Form.Group controlId="check2">
                <Form.Check
                  onChange={() => setCheck2(!check2)}
                  checked={check2}
                  type="checkbox"
                  label="Масса тела новорожденного более 90-го процентиля"
                />
              </Form.Group>
              <Form.Group controlId="check3">
                <Form.Check
                  onChange={() => setCheck3(!check3)}
                  checked={check3}
                  type="checkbox"
                  label="Энцефалопатия новорожденного или другие нарушения церебрального статуса"
                />
              </Form.Group>
              <Form.Group style={{display: 'flex'}} controlId="check4">
                <Form.Check
                  onChange={() => setCheck4(!check4)}
                  checked={check4}
                  type="checkbox"
                />
                <label style={{marginLeft: '10px'}} htmlFor="check4">Синдромом дыхательного расстройства у новорожденного</label>
              </Form.Group>
              <Form.Group controlId="check5">
                <Form.Check
                  onChange={() => setCheck5(!check5)}
                  checked={check5}
                  type="checkbox"
                  label="Врожденный порок сердца и/или врожденные аномалии системы кровообращения у новорожденного"
                />
              </Form.Group>
              <Form.Group style={{display: 'flex'}} controlId="check6">
                <Form.Check
                  onChange={() => setCheck6(!check6)}
                  checked={check6}
                  type="checkbox"
                />
                <label style={{marginLeft: '10px'}} htmlFor="check6">Гипогликемия новорожденного в раннем неонатальном периоде ({'<'}2,6 ммоль/л)</label>
              </Form.Group>
              <Form.Group controlId="check7">
                <Form.Check
                  onChange={() => setCheck7(!check7)}
                  checked={check7}
                  type="checkbox"
                  label="Гиперплазия поджелудочной железы у новорожденного (увеличение размеров тела (>5,9 мм), и/или хвоста (>9,3 мм), и/или выше референсных значений)"
                />
              </Form.Group>
            </Form>
          </div>
          <Button
            className="colbut"
            variant="primary"
            onClick={result}
            style={{ marginTop: "1.25rem" }}
          >
            Продолжить
          </Button>
         
        </div>
      </Container>
    </div>
  );
}

export default Table8;
